import React from 'react';
import Navigation from '../components/Navigation';
import HeroSection from '../components/HeroSection';
import ProductSection from '../components/ProductSection';
import ProductPopup from '../components/ProductPopup';
import AboutSection from '../components/AboutSection';
import ServicesSection from '../components/ServicesSection';
import BenefitsSection from '../components/BenefitsSection';
import TargetAudienceSection from '../components/TargetAudienceSection';
import ReferencesSection from '../components/ReferencesSection';
import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';
import CookieBanner from '../components/CookieBanner';

export default function HomePage() {
  return (
    <div data-testid="home-page" className="overflow-x-hidden">
      <Navigation />
      <HeroSection />
      <ProductSection />
      <AboutSection />
      <ServicesSection />
      <BenefitsSection />
      <TargetAudienceSection />
      <ReferencesSection />
      <ContactSection />
      <Footer />
      <CookieBanner />
      <ProductPopup />
    </div>
  );
}
